import apiClient from '../client';

export interface EmailRequest {
  email: string;
}

export interface ChangesRequestedRequest extends EmailRequest {
  comments?: string;
}

export interface OnboardingRoleSelectedRequest extends EmailRequest {
  role: 'genius' | 'client';
}

export interface DirectEmailRequest {
  to: string;
  subject: string;
  body: string;
}

/**
 * Send profile submitted email
 */
export async function sendProfileSubmittedEmail(email: string): Promise<void> {
  await apiClient.post('/emails/genius-profile-submitted', { email });
}

/**
 * Send profile approved email
 */
export async function sendProfileApprovedEmail(email: string): Promise<void> {
  await apiClient.post('/emails/genius-profile-approved', { email });
}

/**
 * Send profile changes requested email
 */
export async function sendProfileChangesRequestedEmail(email: string, comments?: string): Promise<void> {
  await apiClient.post('/emails/genius-profile-changes-requested', { email, comments });
}

/**
 * Send genius profile completed email
 */
export async function sendGeniusProfileCompletedEmail(email: string): Promise<void> {
  await apiClient.post('/emails/genius-profile-completed', { email });
}

/**
 * Send profile featured email
 */
export async function sendProfileFeaturedEmail(email: string): Promise<void> {
  await apiClient.post('/emails/genius-profile-featured', { email });
}

/**
 * Send client profile completed email
 */
export async function sendClientProfileCompletedEmail(email: string): Promise<void> {
  await apiClient.post('/emails/client-profile-completed', { email });
}

/**
 * Send onboarding role selected email
 */
export async function sendOnboardingRoleSelectedEmail(email: string, role: 'genius' | 'client'): Promise<void> {
  await apiClient.post('/emails/onboarding-role-selected', { email, role });
}

/**
 * Send direct email from admin to a user
 */
export async function sendDirectEmail(to: string, subject: string, body: string): Promise<void> {
  await apiClient.post('/emails/direct', { to, subject, body });
}

export const emailService = {
  sendProfileSubmittedEmail,
  sendProfileApprovedEmail,
  sendProfileChangesRequestedEmail,
  sendGeniusProfileCompletedEmail,
  sendProfileFeaturedEmail,
  sendClientProfileCompletedEmail,
  sendOnboardingRoleSelectedEmail,
  sendDirectEmail,
};
